import { Box, Button, Group, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { Link, useLocation } from 'react-router-dom'
import { avisosDeAcesso, useAcessoServidores } from '@/hooks/useAcessoServidores'

/**
 * Faixa do layout quando falta algo para a pessoa entrar nos servidores com o
 * proprio usuario do LDAP (consoleai#26229). Montada abaixo do Header, como o
 * `PreviewBanner`.
 *
 * Fora de `/perfil` e de `/ssm`: o perfil tem o proprio cartao da senha UNIX, e a
 * pagina Servidores desenha o alerta no topo — a faixa ali seria o mesmo aviso duas
 * vezes na mesma tela.
 */
export function AcessoServidoresBanner() {
  const { pathname } = useLocation()
  const { data } = useAcessoServidores()

  if (pathname.startsWith('/perfil') || pathname.startsWith('/ssm')) return null
  const avisos = avisosDeAcesso(data)
  if (avisos.length === 0) return null

  return (
    <>
      {avisos.map((aviso) => (
        <Box
          key={aviso.tipo}
          role="status"
          style={{
            backgroundColor: aviso.gravidade === 'danger'
              ? 'var(--mantine-color-red-light)'
              : 'var(--mantine-color-yellow-light)',
            borderBottom: '1px solid var(--ai-border-light)',
            padding: '6px 24px',
            flexShrink: 0,
          }}
        >
          <Group gap="sm" justify="space-between" wrap="nowrap">
            <Group gap="xs" wrap="nowrap">
              <IconAlertTriangle
                size={16}
                color={aviso.gravidade === 'danger'
                  ? 'var(--mantine-color-red-light-color)'
                  : 'var(--mantine-color-yellow-light-color)'}
                style={{ flexShrink: 0 }}
              />
              <Text size="sm">{aviso.texto}</Text>
            </Group>
            {aviso.acao && (
              <Button
                component={Link}
                to={aviso.acao.para}
                size="xs"
                variant="light"
                color="yellow"
                style={{ flexShrink: 0 }}
              >
                {aviso.acao.rotulo}
              </Button>
            )}
          </Group>
        </Box>
      ))}
    </>
  )
}
